<template>
  <h1 class="text-center">Pricing</h1>
</template>

<script>
export default {
  name: "Pricing"
}
</script>

<style scoped>

</style>